export default __webpack_public_path__ + "static/media/LOC氨氮（水杨酸法）自动分析仪用户手册_V2.0_fmt_pdf.28a1469e.pdf";